import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 px-6 bg-brand-cream" data-id="element-59">
      <div className="max-w-3xl mx-auto" data-id="element-60">
        {/* Decision Block */}
        <FadeIn data-id="element-61">
          <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-gray-200 mb-12" data-id="element-62">
            <h2 className="text-3xl font-bold text-center mb-8 text-brand-charcoal" data-id="element-63">
              ¿Qué pasa si no haces nada hoy?
            </h2>

            <div className="space-y-4 mb-8" data-id="element-64">
              <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl" data-id="element-65">
                <span className="text-2xl" data-id="element-66">😔</span>
                <p className="text-lg text-gray-700" data-id="element-67">
                  Mañana habrá otra crisis.
                </p>
              </div>
              <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl" data-id="element-68">
                <span className="text-2xl" data-id="element-69">😔</span>
                <p className="text-lg text-gray-700" data-id="element-70">
                  Vas a improvisar otra vez.
                </p>
              </div>
              <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl" data-id="element-71">
                <span className="text-2xl" data-id="element-72">😔</span>
                <p className="text-lg text-gray-700" data-id="element-73">
                  Vas a sentir lo mismo de siempre.
                </p>
              </div>
            </div>

            <div className="h-px bg-gray-300 my-8" data-id="element-74"></div>

            <div className="flex items-center gap-3 p-6 bg-brand-sage-light rounded-xl mb-8" data-id="element-75">
              <span className="text-3xl" data-id="element-76">✅</span>
              <p className="text-xl font-bold text-brand-charcoal" data-id="element-77">
                O puedes tener un plan en las próximas 2 horas.
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Emotional Close */}
        <FadeIn delay={0.2} data-id="element-78">
          <div className="bg-white p-10 rounded-3xl shadow-sm border border-gray-100 mb-12 text-center" data-id="element-79">
            <p className="text-lg text-gray-600 mb-6 italic" data-id="element-80">
              Esto no te convierte en un padre o madre perfecto.
              <br data-id="element-81" />
              Nada lo hace.
            </p>

            <p className="text-xl font-bold text-gray-900 mb-6" data-id="element-82">
              Pero sí te da algo que la mayoría no tiene:
            </p>

            <p className="text-2xl font-serif font-bold text-brand-sage mb-8" data-id="element-83">
              Una respuesta preparada para el momento en que más la necesitas.
            </p>

            <div className="space-y-3 text-lg text-gray-700 mb-10" data-id="element-84">
              <p data-id="element-85">Tu hijo no necesita que nunca te equivoques.</p>
              <p className="font-medium" data-id="element-86">
                Necesita un adulto que vuelva a la calma más rápido que antes.
              </p>
              <p className="text-xl font-bold text-brand-charcoal mt-6" data-id="element-87">
                Ese adulto puedes ser tú.
              </p>
            </div>

            {/* BIGGEST CTA */}
            <Button onClick={scrollToPricing} className="w-full md:w-auto text-2xl py-6 px-12 mb-6" data-id="element-88">
              👉 QUIERO EMPEZAR HOY
            </Button>

            <p className="text-gray-600 font-medium mb-2" data-id="element-89">
              Protocolo Calma 3 Minutos — $9.99
            </p>
            <p className="text-sm text-gray-500" data-id="element-90">
              Acceso inmediato • Garantía de 7 días
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}